<div class="step-indicator-container">
  <span
    class="step-text-indicator"
    [innerHTML]="'stepOfSteps' | i18n: currentIndex + 1 : steps.length"
  ></span>
  <div class="tw-mt-4 tw-h-0.5 tw-w-full tw-bg-dt-surface-elevated">
    <div
      class="tw-h-0.5 tw-bg-dt-custom-teal-9"
      [style.width.%]="((currentIndex + 1) / steps.length) * 100"
    ></div>
  </div>
</div>
